export default "__VITE_ASSET__QVwL6CUT__"